// Wraps every cart-page link on the page with a `<drawer-trigger>` element so
// clicks toggle the sidecart instead of navigating to the cart page.
//
// IMPORTANT: this module's inline code runs at import time. It MUST be
// imported before any cart custom elements (cart-data-conditions, cart-data-array,
// etc.) are registered. The reason:
//
// `<cart-data-conditions>`'s component setup calls `element.replaceChildren(...[])`
// during connectedCallback to strip its `<template conditions="…">` children
// out of the live DOM (it keeps in-memory references to those templates and
// uses them to drive Solid's For/Show output). If we wrap the cart link AFTER
// that setup has already run, `cloneNode(true)` on the link captures the
// post-mutation state — the cloned `<cart-data-conditions>` has no templates
// inside it. When the clone connects, its setup logs "no templates found with
// any conditions attribute!" and renders nothing, breaking the cart count
// badge in the header.
//
// By running BEFORE cart components are defined, the cloned
// `<cart-data-conditions>` still has its templates as real DOM children.
// When the cart custom element is later registered, the registry upgrades
// every existing instance — including our cloned one — and they all
// initialize correctly.
//
// Re drawer-trigger: it doesn't need to be defined at wrap time either. We
// create the element and insert it; when `@brytdesigns/web-component-drawer`
// is later imported (via sidecart.ts), the registry upgrades existing
// drawer-trigger elements and attaches their click handlers.

const sidecart = document.getElementById('ajaxCartDrawer');
if (sidecart) {
  const cartUrl = window.BrytDesigns?.routes?.cart_url?.replace('.js', '');
  if (cartUrl) {
    const cartLinks = Array.from(document.querySelectorAll<HTMLAnchorElement>(`a[href="${cartUrl}"]`));
    for (const link of cartLinks) {
      // Idempotency guard — if this module is somehow imported twice (e.g.
      // via different bundle chunks), skip links that are already wrapped.
      if (link.parentElement?.tagName === 'DRAWER-TRIGGER') continue;

      const linkClone = link.cloneNode(true) as HTMLAnchorElement;
      const drawerTrigger = document.createElement('drawer-trigger');
      drawerTrigger.appendChild(linkClone);
      drawerTrigger.setAttribute('target', '#ajaxCartDrawer');
      drawerTrigger.setAttribute('on', 'click');
      drawerTrigger.setAttribute('prevent-default', 'true');
      drawerTrigger.setAttribute('action', 'toggle');
      link.replaceWith(drawerTrigger);
    }
  }
}
